export default {
  // Date picker
  rangeSeparator: "to",
  startDate: "Start Date",
  endDate: "End Date",

  // Search
  searchTxHash: "Search Transaction Hash",

  // Buttons
  reset: "Reset",
  query: "Query",

  // Data statistics
  totalData: "Total",
  dataUnit: "records",

  // Message prompts
  alreadyCurrentPage: "Already on the current address details page!",
};
